// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1cUh0","name":"Header_name__1Wkfj","birthday":"Header_birthday__W6UsJ","skeleton":"Header_skeleton__6a4ZW"};